import {TalentCategoryId} from '../../../services/talentSearchApi';

export const TALENT_RESULTS_PER_PAGE = 12;

export type StructuredFilters = {
  sport: string;
  artForm: string;
  serviceType: string;
  skillLevel: string;
  proficiencyLevel: string;
  location: string;
};

export const normalizeTalentFilters = (
  filters: StructuredFilters,
  category: TalentCategoryId
): StructuredFilters => ({
  ...filters,
  sport: category === 'all' || category === 'athletic' ? filters.sport : '',
  skillLevel: category === 'all' || category === 'athletic' ? filters.skillLevel : '',
  artForm: category === 'all' || category === 'artistic' ? filters.artForm : '',
  proficiencyLevel: category === 'all' || category === 'artistic' ? filters.proficiencyLevel : '',
  serviceType: category === 'all' || category === 'general' ? filters.serviceType : '',
});

export const formatTalentRange = (total: number, page: number, visible: number) => {
  if (!total || !visible) return 'Showing 0 results';
  const start = (page - 1) * TALENT_RESULTS_PER_PAGE + 1;
  return `Showing ${start}-${Math.min(total, start + visible - 1)} of ${total} results`;
};

export const getTalentPaginationItems = (page: number, total: number): Array<number | 'ellipsis'> => {
  if (total <= 7) return Array.from({length: total}, (_, index) => index + 1);
  const visible = new Set<number>([1, total, page]);
  if (page <= 4) [2, 3, 4, 5].forEach((value) => visible.add(value));
  else if (page >= total - 3) [total - 4, total - 3, total - 2, total - 1].forEach((value) => visible.add(value));
  else [page - 1, page + 1].forEach((value) => visible.add(value));

  return [...visible]
    .filter((value) => value > 0 && value <= total)
    .sort((left, right) => left - right)
    .reduce<Array<number | 'ellipsis'>>((items, value, index, source) => {
      if (index && value - source[index - 1] > 1) items.push('ellipsis');
      items.push(value);
      return items;
    }, []);
};
